import { fetchApi } from '@/config/axiosSetting';
import {
  GetCostsQueryResponseType,
  IGetCostsQueryParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQuery.type';

export const getCostsFunction = (
  params: IGetCostsQueryParams,
): Promise<GetCostsQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/costs/`,
    { params },
  );
};
